<template>
	<div
		class="user-points"
	>
		<div class="user-points__box">
			<SVGStar class="user-points__icon"/>
			<span
				class="user-points__text"
				v-html="$t('club.levels.pointsRedeemable', { points: points })"
			/>
		</div>
		<div
			class="user-points__disclaimer"
			v-html="$t('club.levels.appDisclaimer')"
		/>
	</div>
</template>

<script>
export default {
	props: {
		points: {
			type: Number,
			default: 0
		}
	}
}
</script>

<style>

</style>
